export default "__VITE_ASSET__CJEaCz8G__"